/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
//import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import '../../index.css'
import dayjs from 'dayjs'

type Props = {
  className: string
  data: any
  text: string
  header: any
}

const TableBox = ({className, data, text, header}: Props) => {
  console.log('data', data)
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{text}</span>
          <span className='text-muted mt-1 fw-semibold fs-7'></span>
        </h3>
        <div
          className='card-toolbar'
          data-bs-toggle='tooltip'
          data-bs-placement='top'
          data-bs-trigger='hover'
          title='Click to add a user'
        ></div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3 tableScroll'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead className='stickyHead'>
              <tr className='fw-bold text-muted'>
                <th className='min-w-150px'>{header[0]}</th>
                <th className='min-w-140px'>{header[1]}</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}

            <tbody>
              {data.map((row: any, index: any) => (
                <tr>
                  <td>
                    <div className='d-flex align-items-center'>
                      <div className='d-flex justify-content-start flex-column'>
                        <a href='#' className='text-dark fw-bold text-hover-primary fs-6'>
                          {dayjs(row.text).format('DD-MM-YYYY')}
                        </a>
                      
                      </div>
                    </div>
                  </td>
                  <td>
                    <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                      {row.sum}
                    </a>
                    
                  </td>
                </tr>
              ))}
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
  )
}

export {TableBox}
